import { z } from "zod";
import { timestampSchema } from "./timestamp";
import { choreKindSchema, choreSizeSchema, sportUnitSchema } from "./chore";

export const completionStatusSchema = z.enum([
  "pending",
  "approved",
  "rejected",
]);
export type CompletionStatus = z.infer<typeof completionStatusSchema>;

export const completionSchema = z.object({
  id: z.string(),
  choreId: z.string(),
  choreTitle: z.string(),
  rewardMinor: z.number().int().nonnegative(),
  // Snapshot z chore.kind w momencie zaznaczenia "zrobione". Stabilizuje
  // liczenie XP nawet gdy rodzic później zmieni typ chore.
  // Default "extra" = backward-compat dla starych completion bez pola.
  kind: choreKindSchema.default("extra"),
  // Snapshot z chore.offline. Liczy się do statystyki "aktywność poza ekranem"
  // i zacieśnia odznaki kategorii time.
  offline: z.boolean().default(false),
  // Snapshot z chore.size w momencie zgłoszenia. Stabilizuje XP nawet
  // gdy parent później zmieni size chore'a. Default "M" = backward-compat
  // dla completion sprzed wprowadzenia pola.
  size: choreSizeSchema.default("M"),
  completedBy: z.string(),
  completedAt: timestampSchema,
  // dueDate = na który dzień (północ lokalna). Pozwala filtrować "dziś"
  dueDate: timestampSchema,
  status: completionStatusSchema,
  approvedBy: z.string().optional(),
  approvedAt: timestampSchema.optional(),
  rejectionReason: z.string().max(200).optional(),
  // Snapshot funduszodawcy z chore.fundedBy (lub chore.createdBy fallback)
  // — żeby raz zatwierdzony completion miał stabilną informację kto płaci.
  fundedBy: z.string().optional(),
  // Zdjęcie-dowód (URL z Firebase Storage). Wymagane gdy chore.requiresPhoto.
  // Parent widzi w Approvals przez `getProofSignedUrl` CF (FAZA 7) — krótkotrwały
  // signed URL, nie wczytuje proofPhotoUrl bezpośrednio.
  proofPhotoUrl: z.string().url().optional(),
  // Ścieżka w Storage (do delete przy odrzuceniu/cleanup + dla CF signed URL).
  proofPhotoPath: z.string().optional(),
  // === Snapshot pól sport (kind="sport") ===
  // Snapshot z chore.sportUnit przy zgłoszeniu — stabilizuje historię nawet
  // gdyby parent zmienił unit po fakcie.
  sportUnit: sportUnitSchema.optional(),
  // Snapshot z chore.sportTarget przy zgłoszeniu — ile było celem tego razu.
  sportTarget: z.number().int().positive().optional(),
  // Ile dziecko faktycznie zrobiło (powt. lub min). Wpisane przy submit.
  sportDone: z.number().int().nonnegative().optional(),
});
export type Completion = z.infer<typeof completionSchema>;
